module.exports = __webpack_public_path__ + "img/img2.2f9baf46.png";